import styled from "styled-components";

/**
 * Área do DatePicker com rolagem vertical (Mobile)
 */
export const DatePickerAreaMobile = styled.div`
  height: calc(100vh - ${({ theme }) => theme.spacing(30)});
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  padding: ${({ theme }) => theme.spacing(2)};
  padding-top: ${({ theme }) => theme.spacing(4)};
  gap: ${({ theme }) => theme.spacing(3)};
  flex-direction: column;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  display: flex;

  & > div {
    flex: 0 0 auto;
  }

  scrollbar-color: ${({ theme }) => theme.colors.vividBlue}
    ${({ theme }) => theme.colors.lightGray};
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.spacing(1)};
    background: ${({ theme }) => theme.colors.lightGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.vividBlue};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const SelectionModeTabsMobile = styled.div`
  flex: 0 0 auto;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: ${({ theme }) => theme.spacing(1.25)};
  background-color: ${({ theme }) => theme.colors.lightGray};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const SelectionModeButtonMobile = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>`
  min-height: ${({ theme }) => theme.spacing(5)};
  border: 2px solid
    ${({ isActive, theme }) =>
      isActive ? theme.colors.primaryColor : "transparent"};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.white : "transparent"};
  box-shadow: ${({ isActive }) =>
    isActive ? "0 1px 4px rgba(0, 0, 0, 0.12)" : "none"};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const CalendarInstructionMobile = styled.p`
  flex: 0 0 auto;
  width: 100%;
  margin: 0;
  padding: 0 ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

/**
 * Container do calendário (Mobile)
 */
export const DatePickerContainerMobile = styled.div`
  padding-left: ${({ theme }) => theme.spacing(4)};
  padding-right: ${({ theme }) => theme.spacing(4)};
  justify-content: space-between;
  display: flex;
  width: 100%;

  & > p {
    font-size: ${({ theme }) => theme.fontSizes.md};
    text-transform: capitalize;
  }
`;
